module.exports = __webpack_public_path__ + "static/img/2.9bb592f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/sp/2.png
// module id = EqWF
// module chunks = 0